import React, { useEffect, useState } from "react";
// import PropTypes from 'prop-types'
import { useSelector, useDispatch } from "react-redux";
import Link from "next/link";
import DefaultHeader from "../../../molecules/layout/Header/DefaultHeader";
import FullPageLoading from "../../../molecules/layout/Loading/FullPageLoading";
import { getSavedPlans } from "../../../../state/actions/plans/plans";
import PlanCardsList from "../../../organisms/Plans/PlanCardsList";

export const SavedPlans = (props) => {
    const dispatch = useDispatch();
    const [plans, setPlans] = useState([]);
    const plansReducer = useSelector((state) => state.plansReducer);

    // get user plans
    useEffect(() => {
        dispatch(getSavedPlans());
    }, [plansReducer.addSavedPlanLoading, plansReducer.removeSavedPlanLoading]);

    useEffect(() => {
        const plans = [];
        plansReducer.savedPlans.forEach((element) => {
            plans.push(element.building_plan);
        });
        setPlans(plans);
    }, [plansReducer.savedPlans]);

    return (
        <div>
            <DefaultHeader>
                <div className="col-xl-5 col-lg-6 col-md-8 px-5 py-sm mt-sm">
                    <h1 className="text-white">
                        Saved <span className="text-secondary">Plans</span>
                    </h1>
                </div>
            </DefaultHeader>
            {!(plansReducer.getSavedPlansLoading && !plans.length > 0) ? (
                <div>
                    {!!plans && plans.length > 0 ? (
                        <div>
                            <PlanCardsList plans={plans} noFetchSaved />
                        </div>
                    ) : (
                        <div className="row justify-content-center my-10">
                            <p>
                                You haven't saved any plans yet! Head over to
                                the{" "}
                                <Link href="/plans/">
                                    <a className="text-primary text-underline">
                                        catalogue of plans
                                    </a>
                                </Link>{" "}
                                to save one.
                            </p>
                        </div>
                    )}
                </div>
            ) : (
                <FullPageLoading />
            )}
        </div>
    );
};

SavedPlans.propTypes = {
    // props: PropTypes
};

export default SavedPlans;
